var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Box, Typography, TableContainer, TextField, IconButton, InputAdornment } from '@mui/material';
import Table from 'common/Table/Table.component';
import { DeviceInfoStyle } from './DeviceInfo.style';
import withPaginationTable from 'hoc/withPaginationIsolated';
import { FETCH_LIMIT, PAGINATION_LIMIT } from 'globals/global.constants';
import { getDeviceListFail, getDeviceListSuccess, getDeviceSearchListSuccess, getDeviceType, SET_DEVICE_TYPE_VALUE, SET_DEVICE_SEARCH_QUERY, updateDevicePageNumber, GET_DEVICES_LIST_SUCCESS, } from './DeviceInfo.action';
import { API_LOAD_STATE, PAGINATION_TYPE, PaginationFetchTypes, } from 'globals/enums';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import DeviceTypeSelect from './DeviceType';
import { capitalizeFirstLetter } from 'globals/global.functions';
import CloseIcon from '@mui/icons-material/Close';
import { useSearchBarStyles } from 'common/SearchBar/SearchBar.styles';
var DeviceTable = function (props) {
    var headerData = React.useMemo(function () { return [
        { columnId: 'unique_identifier', label: 'Unique Identifier (IMEI/MAC)', width: 180 },
        {
            columnId: 'device_type',
            label: 'Device Type',
            width: 150,
            style: { minWidth: '150px' },
        },
        { columnId: 'member_id', label: 'Member ID', width: 150 },
        { columnId: 'senior_name', label: 'Senior Name', width: 150 },
        { columnId: 'assigned_date', label: 'Linked Date', width: 130 },
        { columnId: 'unlinked_date', label: 'Unlinked Date', width: 110 },
        { columnId: 'status', label: 'Status', width: 110 },
    ]; }, []);
    var rowData = React.useMemo(function () { return ({
        values: [
            {
                dataId: 'unique_identifier',
                format: function (unique_identifier) { return unique_identifier || '-'; },
            },
            {
                dataId: 'device_type',
                format: function (device_type) { return device_type || '-'; },
            },
            {
                dataId: 'member_id',
                format: function (member_id) { return member_id || '-'; },
            },
            {
                dataId: 'senior_name',
                format: function (senior_name) { return senior_name || '-'; },
            },
            {
                dataId: 'assigned_date',
                format: function (assigned_date) { return assigned_date || '-'; },
            },
            {
                dataId: 'unlinked_date',
                format: function (unlinked_date) { return unlinked_date || '-'; },
            },
            {
                dataId: 'status',
                format: function (status) { return capitalizeFirstLetter(status) || '-'; },
            },
        ],
    }); }, [props.deviceList]);
    return (_jsx(Box, { mt: 4, children: _jsx(TableContainer, { children: _jsx(Table, __assign({ headerData: headerData, rowId: 'key', rowData: rowData, noDataMessage: 'No Device found' }, props, { data: props.deviceList })) }) }));
};
var DeviceInfoComponent = function () {
    var searchBarClasses = useSearchBarStyles().classes;
    var classes = DeviceInfoStyle().classes;
    var dispatch = useAppDispatch();
    var deviceType = useAppSelector(function (state) { return state.devicesAdmin.deviceType; });
    var deviceList = useAppSelector(function (state) { return state.devicesAdmin.data; });
    var searchQuery = useAppSelector(function (state) { return state.devicesAdmin.searchQuery; });
    useEffect(function () {
        if (!deviceType && !searchQuery) {
            dispatch({ type: GET_DEVICES_LIST_SUCCESS, payload: { data: [] } });
        }
    }, [dispatch, deviceType, searchQuery]);
    /**
     * @function getData
     * @description apiFunction for getting paginated Devices
     */
    var getData = React.useCallback(function () {
        return getDeviceType(searchQuery, deviceType);
    }, [deviceType, searchQuery]);
    function validateSearchInput(value) {
        if (!value)
            return false;
        if (value.includes(':')) {
            if (!/^[0-9A-Fa-f:]*$/.test(value))
                return false;
            if (value.startsWith(':') || value[1] === ':')
                return false;
            var parts = value.split(':');
            if (parts.length > 6)
                return false;
            for (var i = 0; i < parts.length; i++) {
                if (parts[i].length > 2)
                    return false;
            }
            return true;
        }
        else {
            if (!/^[a-zA-Z0-9]*$/.test(value))
                return false;
            return true;
        }
    }
    var withPaginationProps = React.useMemo(function () {
        var commonProps = {
            getData: getData,
            onSuccess: getDeviceListSuccess,
            onError: getDeviceListFail,
            onSearchSuccess: getDeviceSearchListSuccess,
            tableDataPath: 'devicesAdmin.data',
            rowsPerPage: PAGINATION_LIMIT.devices,
            limit: FETCH_LIMIT.devices,
        };
        return {
            fetchType: PaginationFetchTypes.OFFSET,
            dependency: "".concat(deviceType).concat(searchQuery),
            paginationOffsetProps: __assign(__assign({}, commonProps), { onPageChange: updateDevicePageNumber, className: classes.pagination, offsetPath: 'devicesAdmin.currentPage', loadingPath: 'devicesAdmin.loading', paginationType: PAGINATION_TYPE.PRIMARY, isScrollOnTop: true, pagePath: 'devicesAdmin.currentPage' }),
            searchBarProps: __assign(__assign({}, commonProps), { isNewDesign: true, placeholder: 'Search by IMEI or Serial no.', position: 'flex-start', loadingPath: 'devicesAdmin.loading', initialValue: searchQuery, searchQueryName: searchQuery, disableFrontendSearch: true, renderSearchBar: false, 
                // onSearchChange: (value: string) => validateAndFormatMac(value),
                renderRightSideComponent: function (isDataLoading) { return (_jsxs(Box, { sx: { display: 'flex', gap: '10px' }, children: [_jsx(TextField, { size: 'small', placeholder: 'Search by IMEI / MAC Address', value: searchQuery || '', disabled: isDataLoading === API_LOAD_STATE.PROGRESS, onChange: function (e) {
                                var value = e.target.value;
                                if (value !== '' && !validateSearchInput(value))
                                    return;
                                dispatch({
                                    type: SET_DEVICE_SEARCH_QUERY,
                                    payload: value || '',
                                });
                            }, InputProps: {
                                endAdornment: searchQuery && (_jsx(InputAdornment, { position: 'end', children: _jsx(IconButton, { size: 'small', onClick: function () {
                                            return dispatch({
                                                type: SET_DEVICE_SEARCH_QUERY,
                                                payload: '',
                                            });
                                        }, children: _jsx(CloseIcon, { fontSize: 'small' }) }) })),
                            }, sx: { minWidth: '210px !important' }, className: " ".concat(searchBarClasses.centeredTextField) }), _jsx(DeviceTypeSelect, { disabled: isDataLoading === API_LOAD_STATE.PROGRESS, deviceType: deviceType, hasAllOption: true, serial: searchQuery, onChange: function (e) {
                                dispatch({
                                    type: SET_DEVICE_TYPE_VALUE,
                                    payload: e.target.value,
                                });
                            } })] })); } }),
        };
    }, [classes.pagination, getData, deviceType, searchQuery, deviceList, dispatch]);
    var deviceInfoWithPagination = withPaginationTable(DeviceTable, { deviceList: deviceList }, withPaginationProps);
    return (_jsxs(Box, { className: classes.container, "data-testid": 'device-management', children: [_jsx(Box, { className: classes.deviceListHeader, children: _jsx(Typography, { component: "div", className: classes.deviceListText, variant: 'h2', children: "Device Details" }) }), _jsx(Box, { className: classes.searchbar, children: deviceInfoWithPagination() })] }));
};
export default DeviceInfoComponent;
